import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhoIsForSection() {
  const isFor = ['Creyentes que sienten que su fe se ve opacada por el agotamiento y el desgano.', 'Profesionales que cumplen con todo pero colapsan cada mañana en privado.', 'Personas que sufren de parálisis por análisis y fatiga crónica.', 'Quienes buscan una herramienta práctica que combine ciencia somática y Biblia.'];
  const isNotFor = ['Personas que buscan una cura médica instantánea sin proceso.', "Quienes prefieren la motivación 'tóxica' de alto impacto y gritos.", 'Aquellos que no están dispuestos a dedicar 5 minutos de quietud al despertar.'];
  return <section className="py-12 md:py-14 px-6 bg-cream" data-id="element-166">
      <div className="max-w-5xl mx-auto" data-id="element-167">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-168">
          <div data-id="element-169">
            <FadeIn data-id="element-170">
              <h2 className="font-serif text-xl md:text-2xl text-navy mb-4 flex items-center gap-2" data-id="element-171">
                <span className="w-7 h-7 rounded-full bg-sage/20 flex items-center justify-center text-sage" data-id="element-172">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-173">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-174" />
                  </svg>
                </span>
                Para quién es esto
              </h2>
            </FadeIn>
            <div className="space-y-2" data-id="element-175">
              {isFor.map((item, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-176">
                  <div className="flex items-start gap-2" data-id="element-177">
                    <div className="w-1.5 h-1.5 rounded-full bg-sage mt-2 flex-shrink-0" data-id="element-178"></div>
                    <p className="text-sm md:text-base text-navy/80 leading-relaxed" data-id="element-179">
                      {item}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          <div data-id="element-180">
            <FadeIn delay={0.15} data-id="element-181">
              <h2 className="font-serif text-xl md:text-2xl text-navy mb-4 flex items-center gap-2 opacity-80" data-id="element-182">
                <span className="w-7 h-7 rounded-full bg-red-900/10 flex items-center justify-center text-red-900/50" data-id="element-183">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-184">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-185" />
                  </svg>
                </span>
                Para quién NO es
              </h2>
            </FadeIn>
            <div className="space-y-2" data-id="element-186">
              {isNotFor.map((item, index) => <FadeIn key={index} delay={0.15 + index * 0.08} data-id="element-187">
                  <div className="flex items-start gap-2 opacity-80" data-id="element-188">
                    <div className="w-1.5 h-1.5 rounded-full bg-navy/30 mt-2 flex-shrink-0" data-id="element-189"></div>
                    <p className="text-sm md:text-base text-navy/70 leading-relaxed" data-id="element-190">
                      {item}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}